import {add2ActiveFormPanel, mrbgStore, resetForm, setImgCrop, setSettingsForm, setToken} from '../components/mrbg/mrbgRedux';
import formStyle from '../static/css/MP_forms.module.css';
import {Mrbg} from './Mrbg.js';
import mrbgS2S from './mrbgS2S.js';

Number.prototype.toPrice  = function(){

	if( this === '' )
		return this;

	return (
		new Intl.NumberFormat('en-us')
			.format(
				this.toString()
					.split('.').slice(0,2).join('.')
					.replace( /[^-\d.]|(?<!^)-/g,'' )     // REMOVE ANY CHARACTER BUT DIGIT, A - AT FIRST, AND POINT
			)
	)
}
String.prototype.toPrice  = Number.prototype.toPrice;
String.prototype.isJson   = function(){
	try{return JSON.parse( this )}
	catch{return this}
};
String.prototype.hexToRGB = function(){
	var aRgbHex = this.toLowerCase().match( /[a-f\d]{1,2}/g );
	return [
		parseInt( aRgbHex[0],16 ),
		parseInt( aRgbHex[1],16 ),
		parseInt( aRgbHex[2],16 )
	];
};

Array.prototype.aSort                 = function(){
	return this
		.sort( ( [,a],[,b] ) => a-b )
		.reduce( ( r,[k,v] ) => ( { ...r,[k]: v } ),{} )
}
Array.prototype.removeItem            = function( val ){
	const index = this.indexOf( val );
	if( index> -1 )
		this.splice( index,1 );
	return this
}
Array.prototype.toggleItem            = function( val ){
	const index = this.indexOf( val );
	( index> -1 )?
		this.splice( index,1 ):
		this.push( val );
	return this;
}
Array.prototype.column                = function( colName,colIndex ){

	if( colIndex )
		return this.reduce( ( obj,v ) => ( { ...obj,[v[colIndex]]: v[colName] } ),{} );
	else
		return this.reduce( ( arr,v ) => ( [...arr,v[colName]] ),[] );
}
Array.prototype.max                   = function(){
	return Math.max.apply( null,this );
}
Array.prototype.min                   = function(){
	return Math.min.apply( null,this );
}
Array.prototype.createObjWithThisKeys = function( v ){
	var myObj = {};
	this.map( k => myObj[k] = v )
	return myObj
}
Array.prototype.intersect             = function( arr ){
	return this.filter( v => {
		return arr.indexOf( v ) !== -1;
	})
}
Array.prototype.arrayDiff             = function( arr ){
	return this.filter( v => {
		return arr.indexOf( v ) === -1;
	})
}
Array.prototype.arrayUnique           = function(){
	var x = new Set(this);
	this.length = 0;
	this.push(...x);
	return this;
}
document.getElementByDataID           = ( dataID ) => {
	return document.querySelector( `[data-id="${dataID}"]` );
}

//_________________________________________________________ FORM _______________________________________________________
HTMLFormElement.prototype.mrbgFillForm = async function( data ){

	await this.mrbgReset();
	var
		formID = this.getAttribute( 'data-id' ),
		fs     = JSON.parse(JSON.stringify(mrbgStore.getState().formsSettings[formID]));

	const
		showForm          = async() => {
			if( this.closest( 'ul[data-id="formsList"]' ) )
				mrbgStore.dispatch(add2ActiveFormPanel( formID+'Frame' ) );
		},
		doScroll          = async() => {
			const timer = setTimeout( () => {
				window.scrollTo( 0,this.parentElement.getBoundingClientRect().top+window.scrollY-65 )
				clearTimeout(timer)
			},0 )
		},
		createFormParts   = async() => {
			if( Object.hasOwn(data, '__PL' ) ){
				for( let pn in data.__PL )
					fs.partsLen[pn].currentR = data.__PL[pn];

				delete data.__PL;
				mrbgStore.dispatch(setSettingsForm({[formID]:fs}));
			}
		},
		arrayValues       = async() => {
			for( var k in data ){
				if(
					Array.isArray( data[k] ) &&
					this.querySelectorAll( '[data-type=mrbgSelect][name="'+k.replace( /__num$/,'' )+'"]' ).length == 0 &&
					this.querySelectorAll( 'input[name="'+k+'"][type="file"],input[name="'+k+'[]"][type=file]' ).length == 0
				){
					const newArr = joinArrayKey2Name( data[k],k );
					delete ( data[k] );
					Object.assign( data,newArr );
				}
			}
		},
		joinArrayKey2Name = ( arr,k )         => {
			let newArr = {};
			for( let j = 0; j<arr.length; j++ ){
				if( Array.isArray( arr[j] ) )
					Object.assign( newArr,joinArrayKey2Name( arr[j],`${k}[${j}]` ) );
				else
					newArr[`${k}[${j}]`] = arr[j];
			}
			return newArr;
		},
		fillForm          = async() => {
			fs.op     = data['__TO'] || 'upd';
			fs.msgTxt = Object.hasOwn(data, '__MSG')? data['__MSG']: '';
			fs.btnTxt = data['__FB'] || 'update';
			fs.btnCls = data['__FB'] || 'update';
			const timer = setTimeout( () => {
				Mrbg.keepLoader = false;
				if( document.getElementByDataID( 'mrbgLoader' ) )
					document.getElementByDataID( 'mrbgLoader' ).removeAttribute( 'style' );
				for( var k in data ){

					if( k === '__MSG' )
						continue;
					else if( data[k] === '__DS' )
						fs.disabled = [...fs.disabled,k];

					else if( k==='id' && this.querySelectorAll('input[name=id]:not([type=hidden]),[data-type=mrbgSelect][name=id]').length==0 )
						fs.hideInp = {
							...fs.hideInp,
							[k]: data[k]
						};

					else if( k.substring(k.length-4)==='__HI' )
						fs.hideInp = {
							...fs.hideInp,
							[k.substring(0,k.length-4)]: data[k]
						};

					else if( this.querySelector( 'input[type=file][name="'+k+'"]' ) || this.querySelector( 'input[type=file][name="'+k+'[]"]' ) ){
						if( data[k] ){
							var inputName = this.querySelector( 'input[type=file][name="'+k+'"]' )? k: k+'[]';
							fs            = {
								...fs,
								imgInputName: inputName,
								oldImg: Array.isArray( data[k] )? [...data[k]]: [data[k]],
								disabled: [...fs.disabled,inputName],
								hideInp: {
									...fs.hideInp,
									[inputName]: Array.isArray( data[k] )? [...data[k]]: [data[k]]
								}
							};
						}
					}

					else if( this.querySelector( `.${formStyle.mrbgSelect}[name="${k}"]` ) ){
						fs.STV = {
							...fs.STV,
							[k]: Array.isArray(data[k])? [...data[k]]: data[k]? [data[k]]: []
						}
						if( Object.hasOwn(data, k+'__num' ) )
							fs.STN = {
								...fs.STN,
								[k]: Array.isArray( data[k+'__num'] )? [...data[k+'__num']]: [data[k+'__num']]
							}

						this.querySelector( `.${formStyle.mrbgSelect}[name="${k}"]` ).classList.add( formStyle.inputFlashing )
					}

					else if(
						this.querySelector( 'input[type=checkbox][name="'+k+'"]' ) &&
						this.querySelector( 'input[type=checkbox][name="'+k+'"][value="'+data[k]+'"]' )
					){
						this.querySelector( 'input[type=checkbox][name="'+k+'"][value="'+data[k]+'"]' ).checked = true;
					}

					else if(
						this.querySelector( 'input[type=checkbox][name^="'+( k.split( '[' )[0] )+'["]' ) &&
						this.querySelector( 'input[type=checkbox][name^="'+( k.split( '[' )[0] )+'["][value="'+data[k]+'"]' )
					){
						this.querySelector( 'input[type=checkbox][name^="'+( k.split( '[' )[0] )+'["][value="'+data[k]+'"]' ).checked = true;
					}

					else if( this.querySelector( `input[type=radio][name="${k}"]` ) ){
						let myInput = this.querySelector( `input[type=radio][name="${k}"][value="${data[k]}"]` );
						if( myInput ){
							myInput.checked = true;
							if( myInput.parentElement.getAttribute('data-si') )
								fs.sundryField[k] = myInput.value;
						}
					}

					else if( this.querySelector( `.${formStyle.mrbgTextEditor}[name="${k}"]` ) )
						this.querySelector( `.${formStyle.mrbgTextEditor}[name="${k}"]` ).innerHTML = data[k]

					else if( this.querySelector( 'textarea[name="'+k+'"]' ) ){
						this.querySelector( 'textarea[name="'+k+'"]' ).value = data[k];
						this.querySelector( 'textarea[name="'+k+'"]' ).classList.add( formStyle.inputFlashing );
					}

					else if( this.querySelector( 'input[name="'+k+'"]' ) ){
						let myInput = this.querySelector( 'input[name="'+k+'"]' );
						myInput.classList.add( formStyle.inputFlashing );
						this.querySelector( `.${formStyle.inputFlashing}[name="${k}"]` )?.classList.add( formStyle.inputFlashing );
						this.querySelector( `.${formStyle.mrbgPersianDateTimeFrame}[name="${k}"]` )?.classList.add( formStyle.inputFlashing );
						mrbgTools.triggerChange( this.querySelector( 'input[name="'+k+'"]' ),data[k] );

						if( myInput.getAttribute('data-si') )
							fs.sundryField[k] = myInput.value;
					}
				}
				mrbgStore.dispatch(setSettingsForm({[formID]:fs}))
				clearTimeout(timer);
			},0 )
		},
		unLock            = () => {
			const timer = setTimeout( () => {
				const timer2 = setTimeout( () => {
					Mrbg.lockForm.removeItem( formID );
					this.querySelectorAll(`.${formStyle.inputFlashing}`).forEach(inp=> inp.classList.remove( formStyle.inputFlashing))
					this.querySelectorAll(`.${formStyle.inputFlashing}` ).forEach(inp=> inp.classList.remove( formStyle.inputFlashing ))
					this.querySelectorAll(`.${formStyle.inputFlashing}`   ).forEach(inp=> inp.classList.remove( formStyle.inputFlashing   ))
					clearTimeout(timer2);
				},1000 )
				clearTimeout(timer);
			},0 )
		};


	await
		showForm()
		.then( await doScroll() )
		.then( await createFormParts() )
		.then( await arrayValues() )
		.then( await fillForm() )
		.then( unLock() );
}
HTMLFormElement.prototype.mrbgReset = async function () {

	this.reset();
	this.querySelectorAll('input[type="text"],input[type="tel"],input[type="time"],input[type="hidden"],input[type="search"],input[type="email"]').forEach(inp => {
		mrbgTools.triggerChange(inp, '');
	});
	this.querySelectorAll('[data-type=mrbgTextEditor]').forEach(te => {
		te.innerHTML = '';
	})

	mrbgStore.dispatch(resetForm(this.getAttribute('data-id')));
	if (Object.hasOwn(mrbgStore.getState().__CIO, this.getAttribute('data-id'))) {
		var CIO = {...mrbgStore.getState().__CIO}
		delete CIO[this.getAttribute('data-id')];
		mrbgStore.dispatch(setImgCrop(CIO))
	}
}


//______________________________________________________ MRBG TOOLS ____________________________________________________
export const mrbgTools = {};

//________________________________________________________ EVENT _______________________________________________________
mrbgTools.Evt = {};
// HTML EVENTS
mrbgTools.Evt.change = document.createEvent('HTMLEvents');
mrbgTools.Evt.change.initEvent('change',true,false);
mrbgTools.Evt.change          = new Event( 'change' );
mrbgTools.Evt.selectionchange = document.createEvent( 'HTMLEvents' );
mrbgTools.Evt.selectionchange.initEvent( 'selectionchange',true,false );
mrbgTools.Evt.remove = new Event( 'rmv' );
// MOUSE EVENTS
mrbgTools.Evt.click  = new Event('click', { bubbles: true, cancelable: true });;
// mrbgTools.Evt.click.initEvent( 'click',true,false );
mrbgTools.Evt.mouseup = document.createEvent( 'MouseEvent' );
mrbgTools.Evt.mouseup.initEvent( 'mouseup',true,false );
// TRIGGER EVENT
mrbgTools.triggerChange = ( ele,val ) => {
	let nativeInputValueSetter =
			ele.tagName==='TEXTAREA'?
				Object.getOwnPropertyDescriptor( window.HTMLTextAreaElement.prototype,'value' ).set:
				Object.getOwnPropertyDescriptor( window.HTMLInputElement.prototype,'value' ).set;
	nativeInputValueSetter.call( ele,val );
	var changeEvt = new Event( ele.tagName.toLowerCase(),{ bubbles: true } )
	ele.dispatchEvent( changeEvt );
}


// //_________________________________________________________ URL ________________________________________________________
// mrbgTools.url               = {};
// mrbgTools.url.addParamToUrl = function( name,value ){
// 	var urlParams = new URLSearchParams( window.location.search )
// 	urlParams.set( name,value );
// 	window.location.search = urlParams.toString();
// }

//________________________________________________________ RANGE _______________________________________________________
mrbgTools.rng                     = {};
mrbgTools.rng.addNodeToRange      = function( range,node ){
	range.selectNode( node );
	const selection = window.getSelection();
	selection.removeAllRanges();
	selection.addRange( range );
}
mrbgTools.rng.unWarpNode          = function( range,parentNode ){
	const fragment = document.createDocumentFragment();
	for( let i = 0; i<parentNode.childNodes.length; i++ )
		fragment.appendChild( parentNode.childNodes[i].cloneNode( true ) );
	this.newNode( range,fragment );
}
mrbgTools.rng.deselectText        = function(){
	if( window.getSelection )
		window.getSelection().removeAllRanges();
	else if( document.selection )
		document.selection.empty();
}
mrbgTools.rng.fill                = function( range,mail ){
	if( range && range.toString().length ) return;

	let signs    =
				mail?
					[' ','?','؟','!',',',':','(',')','{','}','[',']']:
					[' ','?','؟','!',',',':','(',')','{','}','[',']','-','_','.','@'],
			sel      = range.startContainer,
			caretPos = range.startOffset,
			content;

	if( sel.nodeName==='#text' )
		content = sel.textContent;
	else{
		let textNode = mrbgTools.rng.findNearestTextNode( sel,caretPos );
		if( !textNode ){
			range.setStart( sel,caretPos );
			range.setEnd( sel,caretPos );
			return;
		}
		sel      = textNode;
		content  = sel.textContent;
		caretPos = 0;
	}

	let conLen = content.length,
			start  = caretPos,
			end    = caretPos;

	if( !signs.includes( content[start-1] ) || !signs.includes( content[start] ) ){
		while( start>0 && !signs.includes( content[start-1] ) ) start--;
		while( end<conLen && !signs.includes( content[end] ) ) end++;
	}

	if( content.substring( start,end ).trim() == '' ){
		range.setStart( sel,caretPos );
		range.setEnd( sel,caretPos );
		return;
	}

	range.setStart( sel,start );
	range.setEnd( sel,end );
}
mrbgTools.rng.findNearestTextNode = function( element,offset ){
	if( element.childNodes.length === 0 ) return null;

	var
		loopCount = Math.max( offset,element.childNodes.length-offset ),
		targetElm;

	// WHEN THERE ARE A TAG AND IMMEDIATELY AFTER IT,THERE ARE A TEXT_NODE THAT START WITH SPACE
	// SUCH AS THIS: <tagName>...textNode OR a tag...</tagName>| ABC
	if(
		element.childNodes[offset] &&
		element.childNodes[offset].nodeName === '#text' &&
		element.childNodes[offset].textContent.startsWith( ' ' ) &&

		element.childNodes[offset-1] &&
		element.childNodes[offset-1].childNodes.length
	){
		targetElm = element.childNodes[offset-1];
		while( targetElm.childNodes.length )
			targetElm = targetElm.lastChild;

		if( targetElm.nodeName === '#text' )
			return targetElm;
	}

	for( let i = 0; i<=loopCount; i++ ){
		if( element.childNodes[offset-i] ){
			targetElm = element.childNodes[offset-i];
			while( targetElm.childNodes.length )
				targetElm = targetElm.lastChild;

			if( targetElm.nodeName === '#text' )
				return targetElm;
		}
		else if( element.childNodes[offset+i] ){
			targetElm = element.childNodes[offset+i];
			while( targetElm.childNodes.length )
				targetElm = targetElm.firstChild;

			if( targetElm.nodeName === '#text' )
				return targetElm;
		}
	}

	return null;
}
mrbgTools.rng.getCursorPos        = function( parent ){
	let
		offset = 0,
		range;

	if( window.getSelection && window.getSelection().getRangeAt ){
		range  =
			window.getSelection().rangeCount?
				window.getSelection().getRangeAt( 0 ):
				null;
		offset = range? range.endOffset: null;
	}
	else if( document.selection && document.selection.createRange ){
		range = document.selection.createRange();
		if( range.parentElement.isContentEditable ){
			let
				editableDiv = range.parentElement,
				tempEl      = document.createElement( 'span' );
			editableDiv.insertBefore( tempEl,editableDiv.firstChild );
			let tempRange = range.duplicate();
			tempRange.moveToElementText( tempEl );
			tempRange.setEndPoint( 'EndToEnd',range );
			offset = tempRange.text.length;
		}
	}

	if(!range)
		return null;
	let node = range.endContainer;

	const nodeIndices = [];
	while( node && node !== parent ){
		if( node.parentNode )
			nodeIndices.unshift( Array.from( node.parentNode.childNodes ).indexOf( node ) );
		node = node.parentNode;
	}

	if( node !== parent )
		return null; // Node is not within parent

	return [offset,nodeIndices];
};
mrbgTools.rng.getParagraph        = function( range ){

	if( !range )
		return [];

	var
		rangesList = [],
		parent     = range.commonAncestorContainer,
		newRange  = document.createRange(),

		start,
		end,
		inlineElement = ['#text','A','EM','SPAN','STRONG'];

	if( mrbgTools.rng.parentElement(parent).closest(`p.${formStyle.mrbgParag}`) )
		parent = mrbgTools.rng.parentElement(parent).closest(`p.${formStyle.mrbgParag}`);

	if( inlineElement.includes(parent.nodeName) ){
		while( inlineElement.includes( parent.parentElement.nodeName ) )
			parent = parent.parentElement;

		start = parent;
		end   = parent;

		while( start.previousSibling && inlineElement.includes( start.previousSibling.nodeName ) )
			start = start.previousSibling;

		while( end.nextSibling && inlineElement.includes( end.nextSibling.nodeName ) )
			end = end.nextSibling;

		range.setStartBefore( start );
		range.setEndAfter( end );

		newRange.setStartBefore( start );
		newRange.setEndAfter( end );

		rangesList.push( newRange.cloneRange() );
	}
	else if( parent.nodeName==='P' ){
		range.setStartBefore( parent );
		range.setEndAfter( parent );
		blockTags( parent )
	}
	else if( ['LI','H3'].includes(parent.nodeName) ){
		range.setStartAfter( parent );
		range.setEndBefore( parent );
		blockTags( parent )
	}
	else if( ['UL','OL','DL'].includes(parent.nodeName) ){
		range.setStartAfter( parent );
		range.setEndBefore( parent );
		listTag( parent )
	}
	else if( parent.nodeName==='DIV' ){
		start = range.startContainer;
		end   = range.endContainer;

		if( start!==parent )
			while( start.parentNode !== parent )
				start = start.parentNode;

		if( end!==parent )
			while( end.parentNode !== parent )
				end = end.parentNode;

		while( start.previousSibling && inlineElement.includes(start.previousSibling.nodeName) )
			start = start.previousSibling;

		while( end.nextSibling && inlineElement.includes( end.nextSibling.nodeName ) )
			end = end.nextSibling;

		range.setStartBefore( start );
		range.setEndAfter( end );

		var
			isEnd = false,
			currentNode = start;
		while( !isEnd ){
			if( !currentNode?.nodeType )
				continue;
			if( ['LI','H3','P'].includes( currentNode.nodeName ) )
				blockTags( currentNode );
			else if( ['UL','OL','DL'].includes( currentNode.nodeName ) )
				listTag( currentNode );
			else if( inlineElement.includes( currentNode.nodeName ) ){
				newRange.setStartBefore( currentNode );
				while( currentNode.nextSibling && inlineElement.includes( currentNode.nextSibling.nodeName ) )
					currentNode = currentNode.nextSibling;
				newRange.setEndAfter( currentNode );

				rangesList.push( newRange.cloneRange() );
			}

			if( currentNode == end )
				isEnd = true;
			currentNode = currentNode.nextSibling;
		}
	}

	function blockTags( tag ){
		newRange.setStartBefore( tag );
		newRange.setEndAfter( tag );
		rangesList.push( newRange.cloneRange() );
	}
	function listTag( tag ){
		tag.querySelectorAll( 'li' ).forEach( li => {
			newRange.setStartBefore( li );
			newRange.setEndAfter( li );
			rangesList.push( newRange.cloneRange() );
		} )
	}
	return rangesList;
};
mrbgTools.rng.getRange            = function( parentEml ){
	if( parentEml )
		parentEml.normalize();

	let
		range,
		parent;
	if( window.getSelection && window.getSelection().getRangeAt && window.getSelection().rangeCount>0 ){
		range  = window.getSelection().getRangeAt( 0 );
		parent = range.commonAncestorContainer;
	}
	else if( document.selection && document.selection.createRange ){
		range  = document.selection.createRange();
		parent = range.parentNode;
	}
	return [range,parent];
};
mrbgTools.rng.highLightText       = function( parent,start,end ){

	if( !parent )
		return false;

	var
		startAnchor,
		endAnchor;

	if( Array.isArray(parent) ){
		[startAnchor, endAnchor] = parent;
	}
	else{
		startAnchor = parent;
		endAnchor   = parent;
	}

	let
		range = document.createRange(),
		sel = window.getSelection();

	range.setStart( startAnchor.childNodes[0],start||0 );
	range.setEnd  ( endAnchor.childNodes[0],end||endAnchor.childNodes[0].textContent.length );

	sel.removeAllRanges();
	sel.addRange( range );
};
mrbgTools.rng.newNode             = function( range,myNode ){
	range.deleteContents();
	range.insertNode( myNode );
};
mrbgTools.rng.newValue            = function( range,myHTML ){
	let
		parent,
		div         = document.createElement( 'div' );
	div.innerHTML = myHTML;
	if( window.getSelection && window.getSelection().getRangeAt ){
		parent = range.commonAncestorContainer;
		range.deleteContents();
		let
			frag = document.createDocumentFragment(),
			child;
		while( ( child = div.firstChild ) )
			frag.appendChild( child );
		range.insertNode( frag );
	}
	else if( document.selection && document.selection.createRange ){
		parent = range.parentElement();
		range.pasteHTML( myHTML );
	}

	( parent.nodeName==='#text' )?
	parent.parentElement.normalize():
	parent.normalize();
};
mrbgTools.rng.parentElement       = function( parent ){
	parent = parent && parent.nodeName==='#text'? parent.parentElement: parent;
	return parent;
};
mrbgTools.rng.setCursorByNode     = function( anchorNode,nextNode ){

	const
		newRange = document.createRange(),
		selection = window.getSelection();

	if( nextNode ){
		if( nextNode && !anchorNode.nextSibling )
			anchorNode.insertAdjacentText( 'afterend','\u00A0')
		newRange.setStartAfter(anchorNode);
		newRange.collapse(true);
	}
	else{
		newRange.selectNodeContents(anchorNode);
		newRange.collapse(false);
	}
	selection.removeAllRanges();
	selection.addRange( newRange );
}
mrbgTools.rng.setCursorByRange    = function( range,pos ){
	const selection = window.getSelection();
	selection.removeAllRanges();

	const newRange = document.createRange();
	if( pos==='start' ){
		newRange.setStart( range.startContainer,range.startOffset );
		newRange.collapse( true );
	}
	else{
		newRange.setEnd( range.endContainer,range.endOffset );
		newRange.collapse( false );
	}
	selection.addRange( newRange );
}
mrbgTools.rng.setCursorPos        = function( target,anchorIndex,pos ){
	let
		range = document.createRange(),
		sel   = window.getSelection();

	for( let i in anchorIndex )
		if( !target )
			return false;
		else if( target.nodeName!=='#text' && target.childNodes.length>=anchorIndex[i] )
			target = target.childNodes[anchorIndex[i]];
		else
			break;

	if( target.nodeName!=='#text' && target.childNodes.length===1 && target.childNodes[0].nodeName==='#text' )
		target = target.childNodes[0];

	pos =
		( target.nodeName==='#text' )?
		Math.min( pos,target.textContent.length ):
		Math.min( pos,target.childNodes.length );

	range.setStart( target,pos );
	range.collapse( true );
	sel.removeAllRanges();
	sel.addRange( range );
};
mrbgTools.rng.setInputCursorPos   = function( input,pos ){
	if( input != null )
		return false;

	if( input.createTextRange ){
		let range = input.createTextRange();
		range.move( 'character',pos );
		range.select();
	}
	else{
		if( input.selectionStart ){
			input.focus();
			input.setSelectionRange( pos,pos );
		}
		else
			input.focus();
	}
};
mrbgTools.rng.toHtml              = function( range ){
	const
		temp = document.createElement('div'),
		clonedFragment = range.cloneContents();
	temp.appendChild(clonedFragment);
	return temp.innerHTML;
};

//___________________________________________________ VOICE RECOGNAIZE _________________________________________________
try{
	var SpeechRecognition           = window.SpeechRecognition || window.webkitSpeechRecognition;
	mrbgTools.recog                 = new SpeechRecognition();
	mrbgTools.recog.lang            = ['fa-IR','en-US','ar-AE','du-Du'];
	mrbgTools.recog.continuous      = false;
	mrbgTools.recog.mrbgTI          = '';
	mrbgTools.recog.listening       = false;
	mrbgTools.recog.maxAlternatives = 1;
}
catch{
	mrbgTools.recog       = Object;
	mrbgTools.recog.start = function(){
	};
}
mrbgTools.recog.onstart     = function(){
	mrbgTools.recog.listening = true;
}
mrbgTools.recog.onend       = function(){
	mrbgTools.recog.listening = false;
	if( ['INPUT','TEXTAREA'].includes( mrbgTools.recog.mrbgTI.tagName ) )
		this.mrbgTI.nextElementSibling.dispatchEvent( mrbgTools.Evt.click );
	else if( mrbgTools.recog.mrbgTI.tagName === 'DIV' && mrbgTools.recog.mrbgTI.getAttribute( 'contenteditable' ) === 'true' )
		this.mrbgTI.previousSibling.querySelector( '[data-id=mrbgTE_mic]' ).dispatchEvent( mrbgTools.Evt.click );
}
mrbgTools.recog.onspeechend = function(){
	if( mrbgTools.recog.listening )
		mrbgTools.recog.stop();
}
mrbgTools.recog.onresult    = function( e ){
	var
		current    = e.resultIndex,
		transcript = e.results[current][0].transcript,
		range,
		parent;

	if( ['INPUT','TEXTAREA'].includes( mrbgTools.recog.mrbgTI.tagName ) ){
		if( typeof mrbgTools.recog.mrbgTI.selectionStart == 'number' ){
			var
				signs  = [' ','?','؟','!','.','،',',',':','(',')','{','}','[',']','-','_'],
				myVal  = mrbgTools.recog.mrbgTI.value,
				len    = myVal.length,
				start  = mrbgTools.recog.mrbgTI.selectionStart,
				end    = mrbgTools.recog.mrbgTI.selectionEnd,
				prev   = mrbgTools.recog.mrbgTI.selectionStart-1,
				myText = '',
				myPos  = '';

			if( start == 0 ){
				if( len>0 )
					transcript = transcript+' ';
			}
			else if( start == len )
				transcript = ' '+transcript;
			else if( signs.includes( myVal[prev] ) && !signs.includes( myVal[start] ) )
				transcript = transcript+' ';
			else if( !signs.includes( myVal[prev] ) && signs.includes( myVal[start] ) )
				transcript = ' '+transcript;
			else if( !signs.includes( myVal[prev] ) && !signs.includes( myVal[start] ) ){
				while( start>0 && !signs.includes( myVal[start-1] ) )
					start--;
				while( end<len && !signs.includes( myVal[end] ) )
					end++;
			}
			myText = myVal.slice( 0,start )+transcript+myVal.slice( end );
			myPos  = ( myVal.slice( 0,start )+transcript ).length;
		}
		else{
			myText = ( mrbgTools.recog.mrbgTI.value+' '+transcript ).trim();
			myPos  = myText.length;
		}

		mrbgTools.triggerChange( this.mrbgTI,myText );
		this.mrbgTI.dispatchEvent( mrbgTools.Evt.change )
		mrbgTools.rng.setInputCursorPos( mrbgTools.recog.mrbgTI,myPos );
	}
	else if( mrbgTools.recog.mrbgTI.tagName === 'DIV' && mrbgTools.recog.mrbgTI.getAttribute( 'contenteditable' ) === 'true' ){
		[range,parent] = mrbgTools.rng.get();
		var parentElm   = mrbgTools.rng.parentElement( parent );

		if( range && ( parentElm.matches( '[data-type="mrbgTextEditor"]' ) || parentElm.closest( '[data-type="mrbgTextEditor"]' ) === mrbgTools.recog.mrbgTI ) )
			mrbgTools.rng.newValue( range,transcript );
		else
			this.mrbgTI.innerHTML += transcript;
	}
};
mrbgTools.recog.onerror     = function( e ){
	console.log( 'Speech recognition error detected: '+e.error );
}

//______________________________________________________ CALENDAR ______________________________________________________
mrbgTools.Calendar               = {
	d: 86400,
	jLaepYear: [
		4,9,
		13,17,21,25,29,33,37,42,
		46,50,54,58,62,66,71,
		75,79,83,87,91,95,99,104,
		108,112,116,120,124,128,132,137,
		141,145,149,153,157,161,165,170,
		174,178,182,186,190,194,198,203,
		207,211,215,219,223,227,231,236,
		240,244,248,252,256,260,264,269,
		273,277,281,285,289,293,297,302,
		306,310,314,318,322,326,331,
		335,339,343,347,351,355,359,364,
		368,372,376,380,384,388,392,397,
		401,405,409,413,417,421,425,430,
		434,438,442,446,450,454,458,463,
		467,471,475,479,483,487,491,496,
		500,504,508,512,516,520,524,529,
		533,537,541,545,549,553,558,
		562,566,570,574,578,582,586,591,
		595,599,603,607,611,615,619,624,
		628,632,636,640,644,648,652,656,661,
		665,669,673,677,681,685,690,
		694,698,702,706,710,714,718,723,
		727,731,735,739,743,747,751,756,
		760,764,768,772,776,780,784,789,
		793,797,801,805,809,813,817,822,
		826,830,834,838,842,846,850,855,
		859,863,867,871,875,879,883,888,
		892,896,900,904,908,912,916,921,
		925,929,933,937,941,945,949,954,
		958,962,966,970,974,978,983,

		987,991,995,999,1003,1007,1011,1016,
		1020,1024,1028,1032,1036,1040,1044,1049,
		1053,1057,1061,1065,1069,1073,1077,1082,
		1086,1090,1094,1098,1102,1106,1110,1115,
		1119,1123,1127,1131,1135,1139,1143,1148,
		1152,1156,1160,1164,1168,1172,1176,1181,
		1185,1189,1193,1197,1201,1205,1209,1214,
		1218,1222,1226,1230,1234,1238,1243,
		1247,1251,1255,1259,1263,1267,1271,1275,1280,
		1284,1288,1292,1296,1300,1304,1308,1313,
		1317,1321,1325,1329,1333,1337,1341,1346,
		1350,1354,1358,1362,1366,1370,1375,
		1379,1383,1387,1391,1395,1399,1403,1408,
		1412,1416,1420,1424,1428,1432,1436,1441,
		1445,1449,1453,1457,1461,1465,1469,1473,1478,
		1482,1486,1490,1494,1498,1502,1507,
		1511,1515,1519,1523,1527,1531,1535,1540,
		1544,1548,1552,1556,1560,1564,1568,1573,
		1577,1581,1585,1589,1593,1597,1601,1606,
		1610,1614,1618,1622,1626,1630,1634,1639,
		1643,1647,1651,1655,1659,1663,1667,1672,
		1676,1680,1684,1688,1692,1696,1700,1705,
		1709,1713,1717,1721,1725,1729,1733,1738,
		1742,1746,1750,1754,1758,1762,1766,1771,
		1775,1779,1783,1787,1791,1795,1799,1804,
		1808,1812,1816,1820,1824,1828,1832,1837,
		1841,1845,1849,1853,1857,1861,1865,1870,
		1874,1878,1882,1886,1890,1894,1898,1903,
		1907,1911,1915,1919,1923,1927,1932,
		1936,1940,1944,1948,1952,1956,1960,1965,
		1969,1973,1977,1981,1985,1989,1993,1997,2002,
		2006,2010,2014,2018,2022,2026,2030,2035,
		2039,2043,2047,2051,2055,2059,2064,
		2068,2072,2076,2080,2084,2088,2092,2097,
		2101,2105,2109,2113,2117,2121,2125,2130,
		2134,2138,2142,2146,2150,2154,2158,2163,
		2167,2171,2175,2179,2183,2187,2191,2196,
		2200,2204,2208,2212,2216,2220,2224,2229,
		2233,2237,2241,2245,2249,2253,2257,2262,
		2266,2270,2274,2278,2282,2286,2290,2295,
		2299,2303,2307,2311,2315,2319,2323,2328,
		2332,2336,2340,2344,2348,2352,2356,2361,
		2365,2369,2373,2377,2381,2385,2389,2394,
		2398,2402,2406,2410,2414,2418,2422,2427,
		2431,2435,2439,2443,2447,2451,2455,2460,
		2464,2468,2472,2476,2480,2484,2488,2493,
		2497,2501,2505,2509,2513,2517,2521,2526,
		2530,2534,2538,2542,2546,2550,2554,2559,
		2563,2567,2571,2575,2579,2583,2587,2592,
		2596,2600,2604,2608,2612,2616,2621,
		2625,2629,2633,2637,2641,2645,2649,2654,
		2658,2662,2666,2670,2674,2678,2682,2686,2691,
		2695,2699,2703,2707,2711,2715,2719,2724,
		2728,2732,2736,2740,2744,2748,2752,2757,
		2761,2765,2769,2773,2777,2781,2786,
		2790,2794,2798,2802,2806,2810,2814,2818,2823,
		2827,2831,2835,2839,2843,2847,2851,2856,
		2860,2864,2868,2872,2876,2880,2884,2889,
		2893,2897,2901,2905,2909,2913,2918,
		2922,2926,2930,2934,2938,2942,2946,2951,
		2955,2959,2963,2967,2971,2975,2979,2984,
		2988,2992,2996,3000
	]
}
mrbgTools.Calendar.j2m           = function( jalalyData, format ){

	let
		[dateTime,dt,timeZone] = mrbgTools.Calendar.primaryMethod( jalalyData ),
		[y,m,d,h,mi,s]      = dt;

	if(
		( m>12 || d>31 || d<1 ) ||
		( m>6 && m<12 && d>30 ) ||
		( m == 12 && !mrbgTools.Calendar.jLaepYear.includes( y ) && d>29 ) ||
		( m == 12 && mrbgTools.Calendar.jLaepYear.includes( y ) && d>30 )
	)
		return 'چنین تاریخی وجود ندارد.';

	// -42531955200 strtotime('0622/3/21 00:00:00') 1/1/0 JALALI DATE
	let interval = -42531955200;
	interval += ( ( y-1 )*365+mrbgTools.Calendar.jLeapYearLen( y ) )*mrbgTools.Calendar.d;
	interval += ( ( m-1 )*30+Math.min( m-1,6 ) )*mrbgTools.Calendar.d;
	interval += d*mrbgTools.Calendar.d;
	interval += h*3600-timeZone;
	interval += mi*60;
	interval += s;

	dateTime =
		new Date( interval*1000 )
			.toISOString()
			.split( '.' )[0]
			.replaceAll( '-','/' )
			.replace( 'T',' ' );

	[y,m,d,h,mi,s] =
		dateTime.split( /\/|\s|:/ );

	if( format=='dateTime' )
		return `${y}-${m}-${d} ${h}:${mi}:${s}`;

	return `${y}-${m}-${d}`;
}
mrbgTools.Calendar.m2j           = function( miladyDate,format ){
	if( miladyDate ){
		format =
			format=='date'?
				{
					timeZone: 'Asia/Tehran',
					year: 'numeric',
					month: '2-digit',
					day: '2-digit'
				}:
				{
					timeZone: 'Asia/Tehran',
					year: 'numeric',
					month: '2-digit',
					day: '2-digit',
					hour: '2-digit',
					minute: '2-digit',
					second: '2-digit'
				};

		if( miladyDate.trim().includes(' ') )
			miladyDate = `${miladyDate.trim().replace(' ','T')}Z`;

		return new Date( miladyDate ).toLocaleString( 'fa-IR-u-nu-latn',format ).replace( ',','' );
	}

	return null;
}
mrbgTools.Calendar.primaryMethod = function( dateTime ){

	dateTime = dateTime.replace( /\/|\s|:/g,'-' ).split( '-' );
	let
		nLen   = dateTime.length,
		dt     = [],
		timeZone;

	if( nLen>=4 ){
		let
			origin_dtz = new Date().toLocaleString( 'en-US',{ timeZone: 'Utc' } ),
			origin_dt  = new Date( origin_dtz ),
			remote_dtz = new Date().toLocaleString( 'en-US',{ timeZone: 'Asia/Tehran' } ),
			remote_dt  = new Date( remote_dtz );
		timeZone     = ( remote_dt-origin_dt )/1000;
	}
	else
		timeZone = 0;

	for( var i = 0; i<6; i++ )
		if( i<nLen )
			dt[i] = parseInt( dateTime[i] );
		else
			dt[i] = ( i<3 )? 1: 0;

	return [dateTime,dt,timeZone];
}
mrbgTools.Calendar.jLeapYearLen  = function( y ){
	let filtered = mrbgTools.Calendar.jLaepYear.filter( cy => {
		if( cy<y ) return y
	} );
	return filtered.length;
}
mrbgTools.Calendar.todey         = function( format ){

	let today = new Date().toLocaleString( 'fa-IR-u-nu-latn',{ timeZone: 'Asia/Tehran' } ).replace( ',','' );

	let
		[date,time] = today.split( ' ' ),
		[y,m,d]    = date.split( '/' ),
		[h,i,s]    = time.split( ':' );

	return format
		.replace( 'Y',y )
		.replace( 'y',y.toString().substring( 3,4 ) )
		.replace( 'm',m )
		.replace( 'd',d )
		.replace( 'h',h )
		.replace( 'i',i )
		.replace( 's',s );
}
mrbgTools.Calendar.dateDiff      = function( begin,end,diffFormat ){

	var diff     = {
			sec: 1000,
			min: 1000*60,
			hor: 1000*60*60,
			day: 1000*60*60*24,
			mon: 1000*60*60*24*30,
			yer: 1000*60*60*24*30*365
		}
	begin    = begin? new Date( begin ).getTime(): new Date().getTime();
	end      = end? new Date( end ).getTime(): new Date().getTime();

	var dateDiff =
				diff[diffFormat]?
					Math.ceil( ( end-begin )/diff[diffFormat] ):
					false;

	return dateDiff
}
mrbgTools.Calendar.isInPeriod    = function( date,begin,end,remindFormat ){

	var
		diff      = {
			sec: 1000,
			min: 1000*60,
			hor: 1000*60*60,
			day: 1000*60*60*24,
			mon: 1000*60*60*24*30,
			yer: 1000*60*60*24*30*365
		},
		dateDiff,
		trgDate   =
			date == 'today'?
				new Date().getTime():
				new Date( date ).getTime(),
		beginDate = new Date( begin ).getTime(),
		endDate   = new Date( end ).getTime();

	dateDiff =
		( diff[remindFormat] && trgDate>=beginDate && trgDate<=endDate )?
			Math.ceil( ( endDate-trgDate )/diff[remindFormat] ):
			false;

	return dateDiff;
}

//_______________________________________________________ COOKIE _______________________________________________________
mrbgTools.cookie     = {};
mrbgTools.cookie.set = function( name,value,day ){
	var expires = '';
	if( day ){
		var date = new Date();
		date.setTime( date.getTime()+( day*24*60*60*1000 ) );
		expires = '; expires='+date.toUTCString();
	}
	document.cookie = name+'='+( value || '' )+expires+'; path=/; secure';
}
mrbgTools.cookie.get = function( name ){
	var
		nameEQ = name+'=',
		ca     = document.cookie.split( ';' );
	for( var i = 0; i<ca.length; i++ ){
		var c = ca[i];
		while( c.charAt( 0 ) == ' ' )
			c = c.substring( 1,c.length );
		if( c.indexOf( nameEQ ) == 0 )
			return c.substring( nameEQ.length,c.length );
	}
	return null;
}
mrbgTools.cookie.rmv = function( name ){
	document.cookie = name+'=; Max-Age=-99999999;';
};

//_____________________________________________________ TEXT TO HTML ___________________________________________________
mrbgTools.toHtml      = {};
mrbgTools.toHtml.msg  = function( msg,cssStyle ){
	if( Array.isArray(msg) )
		msg = msg.join('<br>');
	return this.text( msg,cssStyle );
}
mrbgTools.toHtml.text = function( text,cssStyle ){
	return (
		text
			.replace( /\*{2}([^*]+)\*{2}/g,`<span class="${cssStyle.mrbgStrong}">$1</span>` )
			.replace( /@{2}([^@]+)@{2}/g,`<span class="${cssStyle.mrbgLN}">$1</span>` )
			.replace( /~{2}([^~]+)~{2}/g,'<em>$1</em>' )
			.replace( /\n\r/,'<br/>' )
	);
}

// __________________________________________________  CUSTOM EVENTS ___________________________________________________
mrbgTools.myEvent = {
};
mrbgTools.myEvent.missedFollow           = function(e,id){
	console.log('X')
	e.preventDefault()
	var MD = new FormData();
	MD.append('id',id);
	MD.append('missedFollowNote',prompt('اگر نیاز به توضیح هست بنویسید.'));
	mrbgS2S(null, MD, 'misFlw', 'apoSes' );
}

//_______________________________________________________ LOG OUT ______________________________________________________
mrbgTools.logOut = function(){
	localStorage.setItem( 'token','' );
	mrbgStore.dispatch( setToken({id:undefined}) );
}